import client, { noneAuthClient } from './client'
import {
  NotificationDetail,
  NotificationsParams,
  NotificationListResponse,
  UnReadNotify,
  NotificationType,
} from '@/types'

export const getNotifigations = (params: NotificationsParams) => {
  return client<NotificationListResponse<NotificationDetail>>({
    url: 'messages',
    method: 'GET',
    params,
  })
}

export const getLatestNotifigations = (params: NotificationsParams) => {
  return client<NotificationListResponse<NotificationDetail>>({
    url: 'latest/messages',
    method: 'GET',
    params,
  })
}

export const getNotifigationDetails = (id: number) => {
  return client<NotificationDetail>({
    url: `message/${id}`,
    method: 'GET',
  })
}

export const getNotAuthNotificationDetails = (id: string) => {
  return noneAuthClient<NotificationDetail>({
    url: `message/${id}`,
    method: 'GET',
  })
}

export const deleteNotification = (id: number) => {
  return client<unknown>({
    url: `message/${id}`,
    method: 'DELETE',
  })
}

//(depreacted)
export const getNotifigation = () => {
  return client<NotificationDetail>({
    url: 'message/unread',
    method: 'GET',
  })
}

export const getUnReadCount = () => {
  return client<UnReadNotify>({
    url: 'message/unread-number',
    method: 'GET',
  })
}

export const readNotifications = (ids: number[]) => {
  return client<unknown>({
    url: 'message/batch/read',
    method: 'POST',
    data: { ids },
  })
}

export const readAllNotifications = (data: { origin: NotificationType }) => {
  return client<unknown>({
    url: 'message/read/all',
    method: 'POST',
    data,
  })
}

export const deleteNotifications = (ids: number[]) => {
  return client<unknown>({
    url: 'message/batch/delete',
    method: 'DELETE',
    data: { ids },
  })
}
